var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00071 15.9951C4.76526 15.997 1.84755 14.0488 0.60914 11.0598C-0.62927 8.07071 0.0557342 4.62993 2.34449 2.34307C4.36527 0.322293 7.31061 -0.466909 10.071 0.272745C12.8315 1.0124 14.9876 3.16854 15.7273 5.92897C16.4669 8.68939 15.6777 11.6347 13.6569 13.6555C12.1597 15.1595 10.1229 16.002 8.00071 15.9951ZM1.60408 8.13681C1.64192 11.656 4.51544 14.4835 8.03473 14.4647C11.554 14.4457 14.397 11.5874 14.397 8.06805C14.397 4.54871 11.554 1.69043 8.03473 1.67142C4.51544 1.65259 1.64192 4.48015 1.60408 7.99929V8.13681ZM6.49276 10.6341C6.18142 10.9453 5.67673 10.9451 5.36556 10.6338C5.0545 10.3225 5.05459 9.818 5.36576 9.50684L6.87331 7.99929L5.3661 6.49208C5.05478 6.18075 5.05478 5.676 5.3661 5.36467C5.67743 5.05335 6.18218 5.05335 6.49351 5.36467L8.00071 6.87188L9.50792 5.36467C9.81925 5.05335 10.324 5.05335 10.6353 5.36467C10.9467 5.676 10.9467 6.18076 10.6353 6.49208L9.12812 7.99929L10.6357 9.50684C10.9468 9.818 10.9469 10.3225 10.6359 10.6338C10.3247 10.9451 9.82001 10.9453 9.50867 10.6341L8.00071 9.12669L6.49276 10.6341Z",
    fill: "#AFBBCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.5f2b70f46b4eec68db9897e71b20b115.svg";
export { ForwardRef as ReactComponent };